export default __webpack_public_path__ + "assets/img/avatar-1.e5695cb.png";